export enum BudgetConcept {
  FOOD = "FOOD",
  ACCOMMODATION = "ACCOMMODATION",
  FUEL = "FUEL",
  TRAVEL_EXPENSE = "TRAVEL_EXPENSE",
  BONUS = "BONUS",
  SUBCONTRACT = "SUBCONTRACT",
  VARIOUS = "VARIOUS",
}